<template>
  <v-list class="menu-sidebar" nav>
    <template v-for="(menu, index) in menusUsuario">
      <!-- Menu item sem submenu -->
      <v-list-item
        v-if="!menu.submenu"
        :key="`item-${index}`"
        :to="menu.url"
        link
        class="menu-item"
      >
        <v-list-item-title>{{ menu.titulo }}</v-list-item-title>
      </v-list-item>

      <!-- Menu item com submenu -->
      <v-list-group
        v-else
        :key="`group-${index}`"
        :value="menuAtivo(menu.url)"
        class="menu-group"
        no-action
        @click:activator="toggleMenu(menu)"
      >
        <!-- Menu principal -->
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ menu.titulo }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <!-- Submenus -->
        <div class="submenu-container">
          <v-list-item
            v-for="(submenu, subIndex) in menu.submenu"
            :key="subIndex"
            :to="submenu.url"
            link
            class="submenu-item"
          >
            <v-list-item-title>{{ submenu.titulo }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MenuComponent',

  data() {
    return {
      expandedMenus: []
    }
  },

  computed: {
    ...mapGetters('login', ['usuarioLogado']),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),
    menusUsuario() {      
      if (!this.usuarioLogado?.menus) return []
      return this.usuarioLogado.menus.map(this.mapMenu)
    },
    currentPath() {
      return this.$route.path
    }
  },

  watch: {
    currentPath: {
      immediate: true,
      handler(newPath) {
        this.atualizarMenusExpandidos(newPath);
      }
    },
    moduloAtivo() {
      this.expandedMenus = [];
    }
  },

  methods: {
    mapMenu(menu) {
      const menuMapeado = {
        titulo: menu.menu,
        url: menu.route_link || `/app/${menu.route_name}`,
        icon: menu.icon,
        acl_menu: menu.acl_menu, // Preserva a referência ao menu pai
      }

      if (menu.childs?.length) {
        menuMapeado.submenu = menu.childs.map(this.mapMenu)
      }

      return menuMapeado
    },

    toggleMenu(menu) {
      const index = this.expandedMenus.indexOf(menu.url);
      if (index === -1) {
        // Se o menu não está expandido, expande ele e fecha os outros
        this.expandedMenus = [menu.url];
      } else {
        // Se o menu já está expandido, fecha ele
        this.expandedMenus.splice(index, 1);
      }
    },

    menuAtivo(url) {
      // Verifica se o menu deve estar expandido
      return this.expandedMenus.includes(url)
    },

    atualizarMenusExpandidos(path) {
      // Limpa os menus expandidos
      this.expandedMenus = [];
      
      // Encontra o menu pai da rota atual
      const menuAtual = this.encontrarMenuPorRota(path, this.menusUsuario);
      if (menuAtual) {
        this.expandedMenus = [menuAtual.url];
      }
    },

    encontrarMenuPorRota(rota, menus) {
      for (const menu of menus) {
        // Verifica se a rota pertence a este menu ou seus submenus
        if (menu.submenu) {
          // Se encontrou nos submenus, retorna este menu (pai)
          const found = menu.submenu.some(sub => sub.url === rota);
          if (found) {
            return menu;
          }
        }
        
        // Verifica se é este menu
        if (menu.url === rota) {
          // Se o menu tem um pai (acl_menu), retorna o menu raiz correspondente
          if (menu.acl_menu) {
            return menus.find(m => m.route_name === menu.acl_menu.route_name);
          }
          return menu;
        }
      }
      return null;
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-sidebar {
  width: 100%;
  padding: 0;

  :deep(.v-list-item) {
    min-height: 40px;
    padding: 0;
  }

  :deep(.v-list-item__content) {
    padding: 0;
  }

  :deep(.v-list-item__title) {
    padding: 8px 24px 8px 16px;
    font-size: 15px;
  }

  :deep(.v-list-group__header) {
    padding: 0;
    min-height: 40px;
    
    &.v-list-item--active {
      background-color: var(--v-primary-lighten5);
    }
  }

  .menu-item, 
  .submenu-item {
    &:hover {
      background-color: var(--v-primary-lighten5);
    }

    &.v-list-item--active {
      background-color: var(--v-primary-lighten4);
      
      :deep(.v-list-item__title) {
        color: var(--v-primary-base);
      }
    }
  }

  .menu-group {
    &.v-list-group--active {
      > .v-list-group__header {
        background-color: var(--v-primary-lighten5);
      }
    }
  }

  .submenu-container {
    padding: 0;
    margin: 0;
    background-color: var(--v-primary-lighten6);

    .submenu-item {
      padding-left: 16px;
      
      :deep(.v-list-item__title) {
        padding-right: 24px;
      }
    }
  }
}
</style>
